// extracted by mini-css-extract-plugin
module.exports = {"root":"status-badge_root__8ET7T"};